import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translations from './translations';

const defaultLanguage = navigator.language.split('-')[0];
const supportedLanguages = Object.keys(translations);
const savedLanguage = localStorage.getItem('language');

const lng =
  savedLanguage && supportedLanguages.includes(savedLanguage)
    ? savedLanguage
    : supportedLanguages.includes(defaultLanguage)
      ? defaultLanguage
      : 'en';

i18n.use(initReactI18next).init({
  resources: translations,
  lng,
  fallbackLng: 'en',
  debug: true,
  interpolation: {
    escapeValue: false,
  },
});

i18n.on('languageChanged', (lng) => {
  localStorage.setItem('language', lng);
});

export default i18n;
